<template>
<div class='category'>
  <selector :category="category" :categories="categories" />
  <info :category="category" @edit='$editCategory(category)' v-if="category" />
</div>
</template>

<script>
import lodash from 'lodash'
import Info from './info'
import Selector from './selector'

export default {
  components: {
    'info': Info,
    'selector': Selector
  },
  computed: {
    category() {
      let vm = this
      // find index
      let index = vm.catId ? lodash.findIndex(vm.categories, {
        id: vm.catId
      }) : -1
      return index >= 0 ? vm.categories[index] : null
    },
    catId() {
      return this.$route.params.id ? Number(this.$route.params.id) : null
    },
    categories() {
      return this.$store.state.category.items
    }
  },
  mounted() {
    this.$store.dispatch('category/index')
  }
}
</script>

<style lang="scss" scoped>
.category {
    margin-bottom: $margin-base;
    .category-card {
        margin-top: $margin-base;
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?0e2b1776